import { Component, OnInit } from '@angular/core';
import { Account } from "../../models/account";
import { Router } from '@angular/router';
import { AccountService } from "../../services/account.service";
import { AccountAdd } from "../../models/account-add";
import {Location} from '@angular/common';

@Component({
    selector: 'account-create',
    templateUrl: 'account-create.component.html',
    styleUrls: ['account-create.component.css'],
    moduleId: module.id
})

export class AccountCreateComponent {
    constructor(
        private router: Router,
        private accountService: AccountService,
        private location: Location
    ) {}

    accountAdd:AccountAdd = new AccountAdd();

    save(): void {
        this.accountService.addAccount(this.accountAdd).then(account => {
            if (account) {
                this.router.navigate(['accounts']);
            }
        })
    }

    cancel(): void {
        this.location.back();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/account-create/account-create.component.ts